import { render, staticRenderFns } from "./advsummary.vue?vue&type=template&id=615ba92d"
import script from "./advsummary.vue?vue&type=script&lang=js"
export * from "./advsummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports